(function() {
  "use strict";

  const marqueeInstances = new Map();

  function initializeSwiper(element) {
    const swiperEl = element.querySelector(".marquee-swiper");
    if (!swiperEl) {
      console.error("Marquee: Swiper element not found");
      return null;
    }

    const speedSetting = parseFloat(element.getAttribute("data-movement-speed")) || 70; 
    const direction = element.getAttribute("data-movement-direction") || "normal";
    const gap = parseInt(element.getAttribute("data-gap")) || 24;
    const stopOnHover = element.hasAttribute("data-stop-on-hover");
    
    const speed = speedSetting * 0.3;
    
    console.log("Marquee settings:", { 
      speedSetting, 
      actualSpeed: speed + "s", 
      direction, 
      gap, 
      stopOnHover 
    });
    
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    const originalSlides = Array.from(swiperEl.querySelectorAll(".swiper-slide"));
    const slideCount = originalSlides.length;
    
    if (slideCount === 0) {
      console.error("Marquee: No slides found");
      return null;
    }

    const duplicateCount = Math.ceil(30 / slideCount);
    for (let i = 0; i < duplicateCount; i++) {
      originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.style.marginRight = gap + "px";
        wrapper.appendChild(clone);
      });
    }
    
    originalSlides.forEach(slide => {
      slide.style.marginRight = gap + "px";
    });

    const totalSlides = wrapper.children.length;
    console.log("Marquee: Created", totalSlides, "slides from", slideCount, "originals");

    let currentAnimationId = null;

    requestAnimationFrame(() => {
      let oneSetWidth = 0;
      for (let i = 0; i < slideCount; i++) {
        const slide = wrapper.children[i];
        oneSetWidth += slide.offsetWidth + gap;
      }
      
      console.log("Marquee: One set width calculated:", oneSetWidth + "px");
      
      currentAnimationId = startAnimation(oneSetWidth);
    });

    function startAnimation(oneSetWidth) {
      let currentTranslate = 0;
      let animationId;
      const pixelsPerSecond = oneSetWidth / speed;
      let lastTime = Date.now();
      let isPaused = false;

      function animate() {
        if (!isPaused) {
          const now = Date.now();
          const deltaTime = (now - lastTime) / 1000;
          lastTime = now;

          const moveAmount = pixelsPerSecond * deltaTime;
          
          if (direction === "reverse") {
            currentTranslate += moveAmount;
            if (currentTranslate >= 0) {
              currentTranslate -= oneSetWidth;
            }
          } else {
            currentTranslate -= moveAmount;
            if (Math.abs(currentTranslate) >= oneSetWidth) {
              currentTranslate += oneSetWidth;
            }
          }

          wrapper.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
        }
        
        animationId = requestAnimationFrame(animate);
      }

      animate();

      if (stopOnHover) {
        swiperEl.addEventListener('mouseenter', () => {
          isPaused = true;
        });
        swiperEl.addEventListener('mouseleave', () => {
          isPaused = false;
          lastTime = Date.now(); 
        });
      }

      console.log("Marquee: Animation started", {
        speed: speed + "s",
        oneSetWidth: oneSetWidth + "px",
        direction,
        gap: gap + "px",
        stopOnHover
      });

      return animationId;
    }

    return {
      destroy: () => {
        if (currentAnimationId) {
          cancelAnimationFrame(currentAnimationId);
        }
      },
      el: swiperEl
    };
  }

  function initializeMarquee(element) {
    if (!window.Swiper) {
      console.error("Marquee: Swiper not loaded");
      return;
    }

    try {
      const swiper = initializeSwiper(element);
      if (swiper) {
        marqueeInstances.set(element, { swiper, element });
      }
    } catch (error) {
      console.error("Marquee: Init failed", error);
    }
  }

  function initializeAllMarquees() {
    const marquees = document.querySelectorAll("[data-marquee]");
    console.log(`Marquee: Found ${marquees.length} marquee(s)`);
    marquees.forEach(initializeMarquee);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAllMarquees);
  } else {
    setTimeout(initializeAllMarquees, 100);
  }

  window.Marquee = {
    instances: marqueeInstances,
    reinitialize: initializeAllMarquees
  };

})();
